/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: DisplayConfirmationPage = 1, SendUserToThankyouPage = 2
 */
export enum Routemize_Constants_AfterBookingAction {
    DISPLAY_CONFIRMATION_PAGE = 'DisplayConfirmationPage',
    SEND_USER_TO_THANKYOU_PAGE = 'SendUserToThankyouPage',
}
